import React from "react";

export default function Treat() {
  return (
    <>
      <p>2K Treat</p>
    </>
  );
}
